import {GameStateEnums} from '../../../../../shared/GameEnums'
import {UIGameMechanic} from '../UIGameEventController'
import {UIGameManager} from '../UIGameManager'
import {CardDataController, CardExchangeFormat} from '@colonist/game-card-types'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {CardTypeEnum} from '@colonist/game-states'

export class UIGameCardExchangeController implements UIGameMechanic {
    constructor(uiGameManager: UIGameManager) {
        uiGameManager.eventController.registerUIGameMechanic(this)
    }

    onEvent(data: any, eventType: GameStateEnums.UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.ExchangeCards: this.handleSoundsOnCardExchange(data); break
            default: break
        }
    }

    // eslint-disable-next-line class-methods-use-this
    private handleSoundsOnCardExchange(exchangeData: CardExchangeFormat) {
        // const isDevelopmentCard = this.isDevelopmentCardGiven(exchangeData)
        // if(!isDevelopmentCard) return
        // const isDevelopmentCardBought = exchangeData.givingPlayer == PlayerColor.None
        // if(isDevelopmentCardBought) return Sound.playSound(Sound.SoundType.DevelopmentCardBought)
        // const isDevelopmentCardUsed = exchangeData.receivingPlayer == PlayerColor.None
        // if(!isDevelopmentCardUsed) return

        // const cardUsed = exchangeData.givingCards[0]
        // switch(cardUsed) {
        //     case CardEnum.Monopoly: Sound.playSound(Sound.SoundType.DevelopmentCardMonopoly); break
        //     default: Sound.playSound(Sound.SoundType.DevelopmentCardUsed)
        // }
    }

    // eslint-disable-next-line class-methods-use-this
    private isDevelopmentCardGiven(exchangeData: CardExchangeFormat): boolean {
        if(exchangeData.givingCards.length != 1) return false
        const givingCard = CardDataController.getCardDataForCard(exchangeData.givingCards[0])
        if(givingCard?.cardTypeEnum == CardTypeEnum.Development) return true
        return false
    }
}
